/* Nuit d'Éclat · interactions globales (menu, reveal, panier ajax, toast) */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  var burger = document.querySelector('[data-nde-burger]');
  var mobileNav = document.querySelector('[data-nde-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Scroll reveal ---------- */
  document.documentElement.classList.add('nde-anim');
  setTimeout(function () {
    document.querySelectorAll('.nde-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }, 3500);

  function observeReveal(root) {
    var targets = (root || document).querySelectorAll('.nde-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }
  observeReveal(document);
  document.addEventListener('shopify:section:load', function (e) { observeReveal(e.target); });

  /* ---------- Compteurs animés ---------- */
  function countUp(section) {
    section.querySelectorAll('[data-count]').forEach(function (el) {
      var raw = el.getAttribute('data-count');
      var m = raw.match(/^(\d+)(.*)$/);
      if (!m) { el.textContent = raw; return; }
      var target = parseInt(m[1], 10), suffix = m[2], t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        el.textContent = Math.floor((1 - Math.pow(1 - p, 3)) * target) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }
  document.querySelectorAll('[data-nde-stats]').forEach(function (sec) {
    if (!('IntersectionObserver' in window)) { countUp(sec); return; }
    new IntersectionObserver(function (es, ob) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(sec); ob.disconnect(); } });
    }, { threshold: 0.4 }).observe(sec);
  });

  /* ---------- Toast ---------- */
  var toastTimer = null;
  window.ndeToast = function (html) {
    var t = document.querySelector('[data-nde-toast]');
    if (!t) return;
    var body = t.querySelector('[data-nde-toast-body]');
    if (body) body.innerHTML = html;
    t.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-open'); }, 5000);
  };

  /* ---------- Compteur panier ---------- */
  window.ndeRefreshCart = function () {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-nde-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        return cart;
      })
      .catch(function () { return null; });
  };

  /* ---------- Ajout rapide depuis une carte produit ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nde-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var racine = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    var libelle = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout…';

    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || 'Ajout impossible');
        btn.disabled = false;
        btn.textContent = libelle;
        if (window.ndeRefreshCart) window.ndeRefreshCart();
        if (window.ndeToast) {
          window.ndeToast(btn.dataset.titre + ' ajouté · <a href="' + racine + 'cart">Voir le panier</a>');
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = libelle;
        if (window.ndeToast) window.ndeToast(err.message);
      });
  });

  /* ---------- Formatage prix (toujours en français : 30,00 €) ---------- */
  window.ndeMoney = function (cents) {
    var v = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    // espace insécable avant le symbole, comme la typographie française l'exige
    return v + ' €';
  };
})();
